import "./css/index.scss";

import $ from "jquery";

import { setupCalendar } from "./js/calendar.js";
import { optionsWithNav, setupCarousel } from "./js/carousel.js";
import { setupLeftMenu } from "./js/left-menu.js";
import lightbox from "./js/lightbox.js";
import { setupMenu } from "./js/menu.js";
import { setupActivePage } from "./js/setup-active-page.js";
import { setupLightbox } from "./js/setup-lightbox.js";
import { setupListaParkow } from "./js/setup-lista-parkow.js";
import { setupSelectLinks } from "./js/setup-select-links.js";
import { setupTooltips } from "./js/setup-tooltips.js";
import { setupCookiePolicy } from "./js/cookies.js";
import { setupLinksWithTargetBlank } from "./js/links-with-blank";
// lightbox plugin
export const lightboxE = lightbox;

function onScroll() {
  // console.log(window.pageYOffset)
  const el = $(".go-top");
  const visible = "go-top--visible";
  if (window.pageYOffset > 400) {
    el.addClass(visible);
  } else {
    el.removeClass(visible);
  }
}

function skipToContent() {
  if (window.innerWidth < 768) {
    // const $container = $('body')
    const $scrollTo = $('[name="main-content"]');
    if ($scrollTo.length) {
      // console.log($scrollTo.offset().top)
      // const top =
      //   $scrollTo.offset().top -
      //   $container.offset().top +
      //   $container.scrollTop()
      const top = $scrollTo.offset().top;
      // console.log(top)
      // $container.scrollTop(top)
      // console.log(window.pageYOffset)
      window.scrollTo(0, top);
    }
  }
}

$(function() {
  setupCookiePolicy(window.COOKIE_POLICY_URL);
  setupSelectLinks();
  setupActivePage();
  setupListaParkow();
  // left menu
  setupLeftMenu();
  // main menu
  setupMenu();
  // tooltips
  // setupTooltips()
  // lightbox
  setupLightbox();
  // calendar
  setupCalendar();
  // owl
  setupCarousel(".slider", {
    responsive: {
      0: {
        items: 1
      }
    },
    autoplay: false
  });
  setupCarousel(".gallery-slider__slider", optionsWithNav);
  setupCarousel(".files__slider", optionsWithNav);
  setupCarousel(".gallery-list__slider", optionsWithNav);
  // go-top
  window.addEventListener("scroll", onScroll);
  onScroll();
  $(".go-top").on("click", function(e) {
    e.preventDefault();
    window.scrollTo(0, 0);
  });
  // przeskocz odrazu do treści jesli jest on mobile w<768
  setTimeout(function() {
    skipToContent();
  }, 200);

  //  fix owl carousel dots
  $(".owl-dots").each(function(i, el) {
    $(el)
      .children()
      .each(function(j, dot) {
        var text = "Pokaż slide: " + (j + 1);
        $(dot)
          .find("span")

          .attr("title", text)
          .append('<span class="sr-only">' + text + "</span>");
      });
  });

  //  open search
  $(".search-trigger").click(() => {
    var search = $(".search-tooltip-content");
    search.toggle();
    if (search.css("display") === "block") {
      $("#search-form-q").focus();
    }
  });
  setupLinksWithTargetBlank();
});
